var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message_new",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25,14.9987797 C23.25,15.6755719 23.25,15.8964156 23.25,17.25 C23.25,18.0784271 22.5784271,18.75 21.75,18.75 L11.25,18.75 L5.25,23.25 L5.25,18.75 L2.25,18.75 C1.42157288,18.75 0.75,18.0784271 0.75,17.25 L0.75,2.25 C0.75,1.42157288 1.42157288,0.75 2.25,0.75 C7.08141394,0.75 10.1199196,0.75 12.5356266,0.75",
    id: "path",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 7.5,
    x2: 10.3078607,
    y2: 7.5,
    id: "path",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 12,
    x2: 12,
    y2: 12,
    id: "path",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "note",
    stroke: "#FF0000",
    fill: "#FF0000",
    cx: 19.4959667,
    cy: 6.75,
    r: 6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/new-message.23610c994df7c9d14a051073375b2f3b.svg";
export { ForwardRef as ReactComponent };